module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("71vZC"))).then(() => module.bundle.root('5erN3'));